import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Layout({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "dark";
  });

  /* APPLY THEME */
  useEffect(() => {
    const root = document.documentElement;

    root.setAttribute("data-theme", theme);
    document.body.setAttribute("data-theme", theme);

    localStorage.setItem("theme", theme);
  }, [theme]);

  /* SCROLL TO TOP ON ROUTE CHANGE (premium feel) */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="app-wrapper" data-theme={theme}>
      
      {/* Background Effects */}
      <div className="orb orb-1" aria-hidden="true" />
      <div className="orb orb-2" aria-hidden="true" />
      <div className="orb orb-3" aria-hidden="true" />
      <div className="noise-overlay" aria-hidden="true" />

      {/* Navbar */}
      <Navbar theme={theme} setTheme={setTheme} />

      {/* Main Content */}
      <main className="layout-main" id="main-content">
        {children}
      </main>

      {/* Footer */}
      <Footer theme={theme} />
    </div>
  );
}

export default Layout;